import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getOteFpa = (oteFpaId: number | undefined): Promise<IGetOteFpa> => {
  return axiosDefaultApi.get(`/api/OteFpa/GetOteFpaViaID/${oteFpaId}`);
};

type QueryFnType = typeof getOteFpa;

type UseGetOteFpaOptions = {
  oteFpaId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetOteFpa = ({ oteFpaId , config }: UseGetOteFpaOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getOteFpa_${oteFpaId}`],
    queryFn: () => getOteFpa(oteFpaId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Κατηγορίας ΦΠΑ.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};